<pp-page-header *ngIf="createAccountActivated || forgotPasswordActivated"
				role="navigation"
				[hideBack]="hideBackButton"
				[hideClose]="hideCloseButton"
				[titleToTranslate]="createAccountActivated ? 'CreateAccount.Login.PP' : 'ChangePassword.Login.PP'"
				(backClick)="handleBack()"
				(closeClick)="backToLogin()">

</pp-page-header>

<main class="content">
	<app-login #Login
			   [hidden]="!isLoginDisplayed"
			   class="hide-spaceless"
			   (createAccount)="newAccount()"
			   (forgotPassword)="doForgotPassword()">
	</app-login>

	<app-patient-search #PatientSearch
						[hidden]="!isPatientSearchDisplayed"
						class="hide-spaceless"
						(next)="searchPatientDone($event)"
						(error)="errorDuringPatientSearch($event)"
            (giveBackFocus)="takeFocus($event)">
	</app-patient-search>

	<app-patient-details *ngIf="createAccountActivated"
						 #PatientDetails
						 [hidden]="!isPatientDetailsDisplayed"
						 class="hide-spaceless"
						 (back)="backToSearch($event)"
						 (next)="continueToOneTimeCodeGeneration($event)">
	</app-patient-details>

	<app-one-time-code *ngIf="createAccountActivated || forgotPasswordActivated"
					   #OneTimeCode
					   [hidden]="!isOneTimeCodeDisplayed"
					   class="hide-spaceless"
					   (back)="backFromOneTimeCode($event)"
					   (next)="oneTimeCodeValidationDone($event)"
					   (error)="errorDuringOneTimeCodeValidation($event)">
	</app-one-time-code>

	<app-patient-account *ngIf="createAccountActivated || forgotPasswordActivated"
						 #PatientAccount
						 [hidden]="!isPatientAccountDisplayed"
						 class="hide-spaceless"
						 (back)="backFromPatientAccount($event)"
						 (accountCreated)="continueToAccountCreationSummary($event)"
						 (passwordChanged)="continueToPasswordChangedSummary($event)"
						 (error)="errorDuringAccountCreationOrForgotPassword($event)">
	</app-patient-account>

	<app-summary *ngIf="createAccountActivated || forgotPasswordActivated"
				 #Summary
				 [hidden]="!isSummaryDisplayed"
				 class="hide-spaceless"
				 (backToLogin)="backToLogin()"
				 (backToSearch)="backToSearchFromSummary($event)"
				 (backToOneTimeCode)="backToOneTimeCodeFromSummary($event)">
	</app-summary>
</main>
